import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBlogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/blog/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchBlog(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/blog/?id=${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editBlog(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/blog", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteBlog(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/blog", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateBlogMarqueeStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/blog/marquee-status/${data.id}`, { show_in_marquee: data.show_in_marquee })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
